{
  "infoStocksStatistics": {
    "title": "Статистика",
    "error": "Не удалось получить статистику о компании",
    "marketCap": "Рыночная капитализация",
    "peRatio": "Коэффициент цена/прибыль (TTM)",
    "netIncome": "Чистая прибыль",
    "sharesFloat": "Акции в свободном обращении",
    "dividendYield": "Дивидендная доходность (указанная)",
    "epsBasic": "Базовая прибыль на акцию (TTM)",
    "revenue": "Выручка",
    "beta": "Бета"
  }
}
